import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions } from "libs/reactQuery";

import { LaunchMarketingCampaignResponse } from "../../marketing.types";
import { requestLaunchMarketingCampaign } from "./launchMarketingCampaign.request";

const useLaunchMarketingCampaign = (
  options?: MutationOptions<
    LaunchMarketingCampaignResponse,
    ApiServiceError<ApiError>,
    string
  >
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: requestLaunchMarketingCampaign,
    ...options,
    onSuccess: (data, variables, ctx) => {
      void queryClient.invalidateQueries({
        queryKey: ["marketing", "campaigns"]
      });
      options?.onSuccess?.(data, variables, ctx);
    }
  });
};

export default useLaunchMarketingCampaign;
